export const KEY = {
  backspace: 8,
  left: 37,
  right: 39,
};
